import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import SearchForm from '../components/SearchForm';
import StorageTable from '../components/StorageTable';
import { storageApi } from '../utils/api';
import { StorageData } from '../types/storage';
import Modal from '../components/Modal';
import StorageForm from '../components/StorageForm';
import StorageDetail from '../components/StorageDetail';

const Dashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<StorageData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [modalContent, setModalContent] = useState<{
    type: 'new' | 'edit' | 'detail';
    id?: string;
  } | null>(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await storageApi.getAll();
      if (response.data?.data) {
        setData(response.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      setError('Veri yüklenirken bir hata oluştu');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (results: StorageData[]) => {
    setData(results);
  };

  const handleOpenModal = (type: 'new' | 'edit' | 'detail', id?: string) => {
    setModalContent({ type, id });
  };

  const handleCloseModal = () => {
    setModalContent(null);
  };

  const renderModalContent = () => {
    if (!modalContent) return null;

    switch (modalContent.type) {
      case 'new':
        return <StorageForm onClose={() => {
          handleCloseModal();
          loadData();
        }} />;
      case 'edit':
        return <StorageForm 
          id={modalContent.id} 
          onClose={() => {
            handleCloseModal();
            loadData();
          }} 
        />;
      case 'detail':
        return <StorageDetail 
          id={modalContent.id} 
          onClose={handleCloseModal}
          onEdit={(id) => {
            setModalContent({ type: 'edit', id });
          }}
        />;
      default:
        return null;
    }
  };

  return (
    <Layout>
      <div className="dashboard">
        <div className="dashboard-header">
          <h2>Lastik Deposu Yönetimi</h2>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button
              className="btn btn-primary"
              onClick={() => handleOpenModal('new')}
            >
              Yeni Kayıt
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => navigate('/customers')}
            >
              Müşteriler
            </button>
          </div>
        </div>

        <div className="dashboard-content">
          <div className="card">
            <div className="card-body">
              <SearchForm onSearch={handleSearch} />
            </div>
          </div>

          <div className="card mt-4">
            <div className="card-body">
              {loading ? (
                <div className="loading">Yükleniyor...</div>
              ) : error ? (
                <div className="error-message">{error}</div>
              ) : (
                <StorageTable 
                  data={data} 
                  onOpenDetail={(id) => handleOpenModal('detail', id)}
                  onOpenEdit={(id) => handleOpenModal('edit', id)}
                  onRefresh={loadData}
                />
              )}
            </div>
          </div>
        </div>

        <Modal
          isOpen={!!modalContent}
          onClose={handleCloseModal}
          title={
            modalContent?.type === 'new' ? 'Yeni Kayıt' :
            modalContent?.type === 'edit' ? 'Kaydı Düzenle' :
            'Kayıt Detayı'
          }
        >
          {renderModalContent()}
        </Modal>
      </div>
    </Layout>
  );
};

export default Dashboard; 